import React from 'react';
import { Footer, Text, Box, Row, Col } from 'tailwind-react-ui'

const FooterComponent = () => {
    
    const baseSourceUrl = 'https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/';

    return(
        <Footer bg="dark-purple" p={0}>
            <Box className="landing-container">
                <Row className="md:flex-row-reverse" id="share-coupon-row">
                    <Col flex className="mb-10 md:mb-0 w-full sm:w-full md:w-4/12 lg:w-4/12">
                        <Box className="m-auto md:w-full text-center md:text-right">
                            <a href="https://twitter.com/SixtyniteApp" target="_blank" rel="noopener noreferrer">
                                <img 
                                className="mx-6 md:mx-4 my-auto w-8 inline-flex" 
                                src={baseSourceUrl+'Twitter.png'} 
                                alt={'witter-sixtynite'}/>
                            </a>
                            <a href="https://www.facebook.com/Sixtynite" target="_blank" rel="noopener noreferrer">
                                <img 
                                className="mx-6 md:mx-4 my-auto w-8 inline-flex" 
                                src={baseSourceUrl+'Facebook.png'} 
                                alt={'facebook-sixtynite'}/>
                            </a>
                            <a href="https://www.youtube.com/channel/UCP3zTwI-VmoptEHjiZ07PJQ" target="_blank" rel="noopener noreferrer">
                                <img 
                                className="mx-6 md:mx-4 my-auto w-8 inline-flex" 
                                src={baseSourceUrl+'Youtube.png'} 
                                alt={'youtube-sixtynite'}/>
                            </a>
                        </Box>
                    </Col>
                    <Col className="w-full sm:w-full md:w-8/12 lg:w-8/12">
                        <Box className="my-auto">
                            <Text className="quicksand-bold text-center md:text-left" text={'white'} is="p" size="lg">
                                Copyright © 2020. Todos los derechos reservados <br/>
                                Proudly by KEA
                            </Text>
                        </Box>
                    </Col>
                </Row>
            </Box>
        </Footer>
    );

}

export default FooterComponent;
